/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * no. of vehicle\'s axles
 * @export
 * @interface MonitoredObjectMetadataProfileMergedItemInteger
 */
export interface MonitoredObjectMetadataProfileMergedItemInteger {
    /**
     * 
     * @type {boolean}
     * @memberof MonitoredObjectMetadataProfileMergedItemInteger
     */
    md: boolean;
    /**
     * 
     * @type {number}
     * @memberof MonitoredObjectMetadataProfileMergedItemInteger
     */
    v?: number;
}

export function MonitoredObjectMetadataProfileMergedItemIntegerFromJSON(json: any): MonitoredObjectMetadataProfileMergedItemInteger {
    return MonitoredObjectMetadataProfileMergedItemIntegerFromJSONTyped(json, false);
}

export function MonitoredObjectMetadataProfileMergedItemIntegerFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoredObjectMetadataProfileMergedItemInteger {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'md': json['md'],
        'v': !exists(json, 'v') ? undefined : json['v'],
    };
}

export function MonitoredObjectMetadataProfileMergedItemIntegerToJSON(value?: MonitoredObjectMetadataProfileMergedItemInteger | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'md': value.md,
        'v': value.v,
    };
}


